import { Badge, Segmented } from 'antd';
import { useState, useEffect } from 'react';
import { sendSegmentEvent } from '../../utils/analytics';

export const SegmentedTabs = ({
  options,
  activeTab,
  setActiveTab,
  disabled,
}) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 641);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 641);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleTabChange = (tab) => {
    sendSegmentEvent(`Switched to ${tab} Tab`);
    setActiveTab(tab);
  };

  const hasDocumentsOptions = options && options.length >= 4;

  if (isMobile && hasDocumentsOptions) {
    return (
      <div className="flex gap-2">
        <div className="flex gap-4 flex-wrap bg-[#f5f5f5] rounded-md">
          {options.slice(0, 3).map((option) => (
            <button
              key={option.value}
              className={`mobile-tab-button py-1 px-2 text-sm rounded-md transition-colors ${
                activeTab === option.value
                  ? 'bg-[#00D090] text-white shadow-sm'
                  : 'bg-transparent text-gray-600 hover:bg-gray-100'
              }`}
              onClick={() => handleTabChange(option.value)}
              disabled={disabled}
            >
              <span className="tab-text">{option.label}</span>
              {option.showBanner && (
                <Badge
                  className="tab-badge"
                  dot
                  style={{
                    position: 'absolute',
                    top: '4px',
                    right: '4px',
                  }}
                />
              )}
            </button>
          ))}
          {options.slice(3).map((option) => (
            <button
              key={option.value}
              className={`mobile-tab-button py-1 px-2 text-sm rounded-md transition-colors ${
                activeTab === option.value
                  ? 'bg-[#00D090] text-white shadow-sm'
                  : 'bg-transparent text-gray-600 hover:bg-gray-100'
              }`}
              onClick={() => handleTabChange(option.value)}
              disabled={disabled}
            >
              <span className="tab-text">{option.label}</span>
              {option.showBanner && (
                <Badge
                  className="tab-badge"
                  dot
                  style={{
                    position: 'absolute',
                    top: '4px',
                    right: '4px',
                  }}
                />
              )}
            </button>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="flex justify-center items-center past">
      <Segmented
        options={(options || []).map((option) => ({
          ...option,
          label: option.showBanner ? (
            <>
              <span>{option.label}</span>
              <Badge className="absolute" dot offset={[0, 2]} />
            </>
          ) : (
            option.label
          ),
        }))}
        value={activeTab}
        onChange={(tab) => {
          handleTabChange(tab);
        }}
        disabled={disabled}
      />
    </div>
  );
};
